import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="notFound">
            <h1>404 :(</h1>
            <h2>This page is not available</h2>
        </div>
    );
};

export default NotFound;